import { defineStore } from 'pinia'
import { logFetchWarning } from '~/utils/fetchErrorLog'

export const useWebsiteInfoStore = defineStore('websiteInfo', () => {
  const name = ref('')
  const logo = ref<WebsiteInfo['logo']>({
    fileName: '',
    large: '',
  })
  const description = ref('')
  const metaTitleFront = ref('')
  const metaDescriptionFront = ref('')
  const ogImage = ref()
  const favicon = ref()
  const copyDisabled = ref(false)
  const robotDisabled = ref(false)
  const domainNotFound = ref(false)
  const serverDown = ref(false)
  const { $api } = useNuxtApp()

  const fetch = async () => {
    try {
      const response = await $api<ApiSuccessResponse<WebsiteInfo>>('/website-info')
      const data = response.data
      if (data) {
        update(data)
      }
    } catch (error: any) {
      if (error?.statusCode === 404) {
        domainNotFound.value = true
      } else {
        serverDown.value = true
        logFetchWarning('Failed to fetch website info', error)
      }
    }
  }

  const update = (payload: WebsiteInfo) => {
    name.value = payload.name
    logo.value = payload.logo
    description.value = payload.description
    metaTitleFront.value = payload.metaTitleFront
    metaDescriptionFront.value = payload.metaDescriptionFront
    ogImage.value = payload.ogImage
    favicon.value = payload.favicon
    copyDisabled.value = payload.copyDisabled
    robotDisabled.value = payload.robotDisabled
  }

  return {
    name,
    logo,
    description,
    metaTitleFront,
    metaDescriptionFront,
    ogImage,
    favicon,
    copyDisabled,
    robotDisabled,
    domainNotFound,
    serverDown,
    fetch,
    update,
  }
})
